(() => {
  const root = document.querySelector('[data-accessories-directory]');
  if (!root) return;

  const buttons = [...root.querySelectorAll('[data-family-filter]')];
  const cards = [...root.querySelectorAll('[data-accessory-card]')];
  const groups = [...root.querySelectorAll('[data-accessory-family]')];
  const search = root.querySelector('[data-accessory-search]');
  const empty = root.querySelector('[data-directory-empty]');
  const status = root.querySelector('[data-directory-status]');
  const allowedFamilies = new Set(['all', 'heater-m2', 'cooler-pro']);
  let family = 'all';

  const requestedFamily = new URLSearchParams(window.location.search).get('family');
  if (allowedFamilies.has(requestedFamily)) family = requestedFamily;

  const apply = () => {
    const query = (search?.value || '').trim().toLowerCase();
    let visible = 0;

    cards.forEach((card) => {
      const familyMatch = family === 'all' || card.dataset.family === family;
      const searchMatch = !query || (card.dataset.search || '').includes(query);
      card.hidden = !(familyMatch && searchMatch);
      if (!card.hidden) visible += 1;
    });

    groups.forEach((group) => {
      const hasVisibleCard = [...group.querySelectorAll('[data-accessory-card]')].some((card) => !card.hidden);
      group.hidden = !hasVisibleCard;
    });

    buttons.forEach((button) => {
      const active = button.dataset.familyFilter === family;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    if (empty) empty.hidden = visible !== 0;
    if (status) status.textContent = `${visible} ${visible === 1 ? 'accessory' : 'accessories'} shown`;
  };

  buttons.forEach((button) => button.addEventListener('click', () => {
    family = button.dataset.familyFilter;
    const url = new URL(window.location.href);
    if (family === 'all') url.searchParams.delete('family');
    else url.searchParams.set('family', family);
    history.replaceState({}, '', `${url.pathname}${url.search}${family === 'all' ? '' : `#${family}`}`);
    apply();
  }));

  search?.addEventListener('input', apply);
  apply();
})();
